import classNames from 'classnames';
import { t } from 'ttag';

import { Button } from '@ui/Button';
import { Modal } from '@ui/Modal';
import { Title } from '@ui/Title';
import { Image } from '@ui/Image';

import s from './BonusbackInfoModal.sss';

export interface ModalData {
  icon: string,
  title: string,
  text?: string | null,
  markListItems?: string[] | null,
}

interface Props {
  isOpen: boolean,
  data: ModalData[],
  onClose: () => void,
}

export const BonusbackInfoModal: React.FC<Props> = ({
  isOpen,
  data,
  onClose,
}) => (
  <Modal
    className={classNames(s.modal)}
    isOpen={isOpen}
    onRequestClose={onClose}
    withClose={true}
  >
    <Title
      className={s.title}
      type='h3'
      bold={false}
    >
      {t`Як отримати бонусбек`}
    </Title>

    <ul className={s.list}>
      {data.map((item, i) => (
        <li
          key={i}
          className={s.item}
        >
          <Image
            className={s.icon}
            src={item.icon}
            width='24'
            height='24'
            loading="lazy"
          />

          <div className={s.content}>
            <p className={s.itemTitle}>
              {item.title}
            </p>

            {!!item.text && (
              <p className={s.itemText}>
                {item.text}
              </p>
            )}

            {!!item?.markListItems?.length && (
              <ul className={s.subList}>
                {item.markListItems.map((markItem, j) => (
                  <li
                    key={j}
                    className={s.subItem}
                  >
                    {markItem}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </li>
      ))}
    </ul>

    <Button
      className={s.button}
      onClick={onClose}
    >
      {t`Добре`}
    </Button>
  </Modal>
);
